import React from 'react';
import PropTypes from 'prop-types';
import { MdContentCopy } from 'react-icons/md';

import './clipboard-btn.scss';

const ClipboardBtn = ({ url, btnClass, ...props }) => {

  const handleClick = () => {
    navigator && navigator.clipboard && navigator.clipboard.writeText(url);
  };

  return (
    <button
      data-tip='Copied'
      className={`${btnClass} clipboard-btn`}
      onClick={handleClick}
    >
      <MdContentCopy />
    </button>
  );
};

ClipboardBtn.propTypes = {
  url: PropTypes.string.isRequired,
  btnClass: PropTypes.string,
};

export default ClipboardBtn;
